"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_1 = require("react");
const mobx_react_1 = require("mobx-react");
const Formatters_1 = require("../../common/Formatters");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const CovidPersonApi_1 = __importDefault(require("../../api/CovidPersonApi"));
const PersonDetailsDrawer_1 = __importDefault(require("../common/PersonDetailsDrawer"));
const moment_1 = __importDefault(require("moment"));
const pdfjsLib = __importStar(require("pdfjs-dist/es5/build/pdf"));
const pdf_worker_entry_1 = __importDefault(require("pdfjs-dist/es5/build/pdf.worker.entry"));
const hui_1 = require("@mit/hui");
const VaccineReviewComponent = ({ peopleStore, covidNav, roles }) => {
    const [showPerson, setShowPerson] = (0, react_1.useState)(false);
    const [person, setPerson] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isLoadingMore, setIsLoadingMore] = (0, react_1.useState)(false);
    const [hasMore, setHasMore] = (0, react_1.useState)(true);
    const [isSaving, setSaving] = (0, react_1.useState)({ isLoading: false, id: "" });
    const [isApproving, setIsApproving] = (0, react_1.useState)({ isLoading: false, id: "" });
    const [isPending, setIsPending] = (0, react_1.useState)({ isLoading: false, id: "" });
    const [isRejecting, setIsRejecting] = (0, react_1.useState)({ isLoading: false, id: "" });
    const [hasImage, setHasImage] = (0, react_1.useState)(false);
    const [isReloading, setReloading] = (0, react_1.useState)(false);
    const [loadingVaccine, setLoadingVaccine] = (0, react_1.useState)(false);
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(false);
    const [showCard, setShowCard] = (0, react_1.useState)(false);
    const [data, setData] = (0, react_1.useState)([]);
    const [vaccineType, setVaccineTypes] = (0, react_1.useState)([]);
    const [vaccineCompany, setVaccineCompanies] = (0, react_1.useState)([]);
    const [rejectionTypes, setRejectionTypes] = (0, react_1.useState)([]);
    const [vaccineData, setVaccineData] = (0, react_1.useState)();
    const [selectedVaccineProof, setSelectedVaccineProof] = (0, react_1.useState)();
    const [selectedItemIndex, setSelectedItemIndex] = (0, react_1.useState)(null);
    const [selectedImage, setSelectedImage] = (0, react_1.useState)(null);
    const [alertMessage, setAlertMessage] = (0, react_1.useState)({ text: "", type: "success" });
    const [proofImages, setProofImages] = (0, react_1.useState)([]);
    const [alert, setAlert] = (0, react_1.useState)({
        error: false,
        message: "",
    });
    const [tabs, setTabs] = (0, react_1.useState)("Pending");
    (0, react_1.useEffect)(() => {
        setShowCard(false);
        setLoading(true);
        initData();
    }, []);
    (0, react_1.useEffect)(() => {
    }, []);
    (0, react_1.useEffect)(() => {
        if (selectedItemIndex !== null) {
            if (selectedItemIndex > 49) {
                setSelectedItemIndex(0);
                fetchReviews(tabs);
            }
            const item = data[selectedItemIndex];
            if (item === null || item === void 0 ? void 0 : item.proof_guid) {
                setShowCard(true);
                setLoadingVaccine(true);
                MedicalApi_1.default
                    .fetchPersonVaccineProofsFromGuid(item.proof_guid)
                    .then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    let shots = [];
                    for (let i = 0; i < res.items.shots.length; i++) {
                        const shot = res.items.shots[i];
                        // shot.hasImage = await uploadApi.checkImage(res.items.shots[i].image_url);
                        shots.push(shot);
                    }
                    setLoadingVaccine(false);
                    setVaccineData(Object.assign(Object.assign(Object.assign({}, res.items), { shots: shots.sort((o1, o2) => {
                            if (o1.type_id > o2.type_id)
                                return -1;
                            else if (o1.type_id < o2.type_id)
                                return 1;
                            if (o1.shot_number > o2.shot_number)
                                return -1;
                            else if (o1.shot_number < o2.shot_number)
                                return 1;
                            return 0;
                        }) }), { full_name: item.full_name }));
                }))
                    .catch((e) => {
                    console.error(e);
                });
                MedicalApi_1.default
                    .fetchPersonVaccineDocuments(item.mit_id)
                    .then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    setProofImages([]); //THIS MIGHT BE THE ISSUE
                    for (let i = 0; i < res.items.length; i++) {
                        const img = res.items[i];
                        if (img.mimeType === 'application/pdf') {
                            const blob = yield fetch(img.url).then((r) => __awaiter(void 0, void 0, void 0, function* () { return yield r.blob(); }));
                            // console.log(convertDocToImage(blob))
                            convertDocToImage(blob);
                        }
                        else {
                            setProofImages(prev => [...prev, img.url]);
                        }
                        // shot.hasImage = await uploadApi.checkImage(res.items.shots[i].image_url);
                    }
                }))
                    .catch((e) => {
                    console.error(e);
                });
            }
        }
    }, [selectedItemIndex]);
    (0, react_1.useEffect)(() => {
        if (isReloading) {
            fetchReviews(tabs);
            setReloading(false);
        }
    }, [isReloading]);
    const hasBothDoses = (shots) => {
        if (!shots || shots.length == 0)
            return false;
        let dosesLeft = [1, 2];
        for (let i = 0; i < shots.length; i++) {
            if (shots[i].type_id == 1 && shots[i].status != 'R') {
                const index = shots.indexOf(shots[i].shot_number);
                dosesLeft.splice(index, 1);
            }
        }
        return (dosesLeft.length == 0) ? true : false;
    };
    const hasApprovedBooster = (shots) => {
        if (!shots || shots.length == 0)
            return false;
        let approvedBooster = false;
        for (let i = 0; i < shots.length; i++) {
            if (shots[i].type_id == 2 && shots[i].status == 'A') {
                approvedBooster = true;
                break;
            }
        }
        return approvedBooster;
    };
    const convertDocToImage = React.useCallback((file) => {
        const fileReader = new FileReader();
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdf_worker_entry_1.default;
        fileReader.onload = function (e) {
            return __awaiter(this, void 0, void 0, function* () {
                const typedarray = e.target != null ? new Uint8Array(e.target.result) : '';
                const loadingTask = pdfjsLib.getDocument(typedarray);
                const pdfDoc = yield loadingTask.promise;
                const page = yield pdfDoc.getPage(1);
                const viewport = page.getViewport({ scale: 1.0 });
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const renderContext = {
                    canvasContext: ctx,
                    viewport: viewport
                };
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                const renderTask = page.render(renderContext);
                yield renderTask.promise;
                const image = canvas.toDataURL('image/jpeg');
                setProofImages(prev => [...prev, image]);
            });
        };
        fileReader.readAsArrayBuffer(file);
    }, []);
    //if (error) return <Error context={ErrorContext.Component} message="Failed to fecth Vaccine results" type={ErrorType.Generic} />;
    if (unAuth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    const configs = {
        dataBatchSize: 250,
        vaccineCompanies: vaccineCompany.map((o) => ({ id: o.medical_vaccine_company_guid, text: o.company_name, icon: "" })),
        tabsToStatusMap: [
            { status: null, text: "All", icon: "" },
            { status: "P", text: "Pending", icon: "" },
            { status: "A", text: "Approved", icon: "" },
            { status: "R", text: "Rejected", icon: "" },
        ],
        aproveRejectOptions: [
            { icon: "check", text: "Approved", /* state: vaccineData?.status === "A" ? DropDownState.Active : DropDownState.None, */ badge: 0, status: "A" },
            { icon: "times", text: "Rejected", /* state: vaccineData?.status === "R" ? DropDownState.Active : DropDownState.None, */ badge: 0, status: "R" },
            { icon: "question", text: "Pending", /* state: vaccineData?.status === "P" ? DropDownState.Active : DropDownState.None, */ badge: 0, status: "P" },
        ],
        rejectReasonOptions: rejectionTypes.map((o) => ({
            reason_id: o.id,
            icon: "",
            text: o.shortText,
            state: (vaccineData === null || vaccineData === void 0 ? void 0 : vaccineData.approver_reason) ? hui_1.DropDownState.Active : hui_1.DropDownState.None,
            badge: 0,
        })),
    };
    const methods = {
        selectItem() {
            setShowCard(true);
        },
        cancelUpdate() {
            setData([]);
            setFilterValues((state) => (Object.assign(Object.assign({}, state), { from: 1, to: data.length })));
            setReloading(true);
            setLoading(true);
            setSelectedItemIndex(null);
            setShowCard(false);
            setAlert({
                error: false,
                message: "",
            });
        },
        formatDate(date) {
            return (0, moment_1.default)(new Date(date)).format("MM/DD/YYYY");
        },
    };
    //FILTERS
    const [showFilters, setShowFilters] = (0, react_1.useState)(false);
    const [isFiltering, setIsFiltering] = (0, react_1.useState)(false);
    const [filtered, setFiltered] = (0, react_1.useState)(false);
    const [filterValues, setFilterValues] = (0, react_1.useState)({
        from: 1,
        to: configs.dataBatchSize,
        vaccine_status: tabs,
        name: null,
        vaccine_type: null,
        received_on: null,
        submission_date: null,
    });
    const onOpenFilters = () => {
        var _a;
        let status = (_a = configs.tabsToStatusMap.find((o) => o.text === tabs)) === null || _a === void 0 ? void 0 : _a.text;
        updateFilterValues({ vaccine_status: status });
        setShowFilters(true);
    };
    const getNestedObjectValue = (value, key) => {
        let keys = key.split("/");
        keys.forEach((key) => {
            value = value[key];
        });
        return value;
    };
    const getFilterValue = (id) => {
        if (filterValues.hasOwnProperty(id)) {
            return filterValues[id];
        }
        return null;
    };
    const getFilterItems = (col) => {
        let options = [];
        for (let item of data) {
            let value = getNestedObjectValue(item, col.id);
            if (Array.isArray(value)) {
                for (let option of value) {
                    options.push({
                        id: option.id,
                        text: option.name,
                        icon: "",
                    });
                }
            }
            else {
                options.push({
                    id: "1",
                    text: value,
                    icon: "",
                });
            }
        }
        let unique = [...new Set(...[options.map((option) => option.text)])].map((text) => options.find((obj) => obj.text == text));
        options = unique;
        //SORT ASC
        options = options.sort((a, b) => {
            if (a.text < b.text) {
                return -1;
            }
            if (a.text > b.text) {
                return 1;
            }
            return 0;
        });
        return options;
    };
    const updateFilterValues = (obj) => {
        let filters = {};
        Object.keys(obj).map((key) => {
            filters[key] = obj[key];
        });
        setFilterValues((state) => (Object.assign(Object.assign({}, state), filters)));
    };
    const getFilterInput = (col, i) => {
        var _a, _b, _c, _d, _e, _f;
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: col.id, label: col.name, value: getFilterValue(col.id), editor: ((_a = col.filterOptions) === null || _a === void 0 ? void 0 : _a.type) || "textbox", options: ((_b = col.filterOptions) === null || _b === void 0 ? void 0 : _b.createOptionsOffItems) ? getFilterItems(col) : (_c = col.filterOptions) === null || _c === void 0 ? void 0 : _c.options, items: ((_d = col.filterOptions) === null || _d === void 0 ? void 0 : _d.createOptionsOffItems) ? getFilterItems(col) : (_e = col.filterOptions) === null || _e === void 0 ? void 0 : _e.options, labelDisplay: "ontop", required: false, isRangeSelected: ((_f = col.filterOptions) === null || _f === void 0 ? void 0 : _f.type) === "calendar", onChange: (e) => {
                    var _a;
                    updateFilterValues({ [col.id]: e.target && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.value) !== null ? e.target.value : e.text ? e.text : e });
                } }) }, `filter_input_${i}`));
    };
    const onFilterItems = () => {
        setData([]);
        updateFilterValues({ from: 1, to: configs.dataBatchSize });
        setIsFiltering(true);
        setFiltered(true);
        setShowFilters(false);
    };
    const onClearFilters = () => {
        setShowFilters(false);
        setData([]);
        updateFilterValues({ from: 1, to: configs.dataBatchSize, vaccine_status: null, name: null, vaccine_type: null, received_on: null });
        setIsFiltering(true);
        setFiltered(false);
    };
    const getDateFromRange = (dateTo, dateFrom) => {
        let to = null;
        let from = null;
        if (dateFrom) {
            from = methods.formatDate(`${dateFrom.month}/${dateFrom.day}/${dateFrom.year}`);
            to = methods.formatDate(`${dateFrom.month}/${dateFrom.day}/${dateFrom.year}`);
        }
        if (dateTo) {
            to = methods.formatDate(`${dateTo.month}/${dateTo.day}/${dateTo.year}`);
        }
        return { to, from };
    };
    const fetchReviews = (vaccine_status) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        setIsLoadingMore(true);
        let requestFilters = {
            status: ((_a = configs.tabsToStatusMap.find((o) => o.text === (vaccine_status || filterValues.vaccine_status))) === null || _a === void 0 ? void 0 : _a.status) || null,
            from: filterValues.from,
            to: filterValues.to,
            company: ((_b = configs.vaccineCompanies.find((o) => o.text === filterValues.vaccine_type)) === null || _b === void 0 ? void 0 : _b.id) || null,
            name: filterValues.name || null,
            received_on_to: getDateFromRange((_c = filterValues.received_on) === null || _c === void 0 ? void 0 : _c.to, (_d = filterValues.received_on) === null || _d === void 0 ? void 0 : _d.from).to,
            received_on_from: getDateFromRange((_e = filterValues.received_on) === null || _e === void 0 ? void 0 : _e.from, (_f = filterValues.received_on) === null || _f === void 0 ? void 0 : _f.from).from,
            submission_date_to: getDateFromRange((_g = filterValues.submission_date) === null || _g === void 0 ? void 0 : _g.from, (_h = filterValues.submission_date) === null || _h === void 0 ? void 0 : _h.from).to,
            submission_date_from: getDateFromRange((_j = filterValues.submission_date) === null || _j === void 0 ? void 0 : _j.from, (_k = filterValues.submission_date) === null || _k === void 0 ? void 0 : _k.from).from,
        };
        MedicalApi_1.default
            .getVaccineProofFiltered(requestFilters)
            .then((vaccineProof) => {
            let newSet = vaccineProof.map((proof) => {
                return Object.assign(Object.assign({}, proof), { name: getInfo(proof.name), full_name: getInfo(proof.name), mit_id: getInfo(proof.mit_id), date_of_birth: !proof.dob ? "N/A" : (0, Formatters_1.displayDate)(proof.dob), address: proof.address, vaccine_status: vaccineStatus(proof.status).status });
            });
            let merged = [...data].concat(newSet);
            if (vaccineProof.length === configs.dataBatchSize) {
                setHasMore(true);
                updateFilterValues({ from: merged.length + 1, to: merged.length + configs.dataBatchSize });
            }
            else {
                updateFilterValues({ from: 1, to: configs.dataBatchSize });
                setHasMore(false);
            }
            setData(merged);
            // if (vaccineData?.proof_guid) {
            // 	const index = data?.findIndex((x: any) => x.proof_guid === vaccineData?.proof_guid);
            // 	if (index >= 0) {
            // 		setSelectedItemIndex(index);
            // 	}
            // }
            setLoading(false);
            setIsLoadingMore(false);
        })
            .catch((err) => {
            setLoading(false);
            setIsLoadingMore(false);
        });
    };
    const initData = () => {
        setLoading(true);
        Promise.all([MedicalApi_1.default.fetchVaccineCompanies(), MedicalApi_1.default.fetchVaccineTypes(), MedicalApi_1.default.fetchRejectionTypes()]).then(([companies, vaccineTypes, rejectionTypes]) => {
            setVaccineTypes(vaccineTypes);
            setVaccineCompanies(companies);
            setRejectionTypes(rejectionTypes);
            setHasMore(true);
        });
    };
    const getInfo = (info) => {
        if (!info || !info.length) {
            return "N/A";
        }
        return info;
    };
    const vaccineStatus = (status) => {
        let vaccineStatus = {
            P: { status: "Pending", color: "status-pending", alertColor: "warning", badgeColor: "info" },
            A: { status: "Approved", color: "status-approved", alertColor: "success", badgeColor: "success" },
            R: { status: "Rejected", color: "status-rejected", alertColor: "error", badgeColor: "danger" },
        };
        return vaccineStatus[status];
    };
    const viewPersonClose = () => {
        setPerson(undefined);
        setShowPerson(false);
    };
    const showPersonInfo = (item) => {
        setShowPerson(false);
        CovidPersonApi_1.default.fetchPerson(item.mit_id).then((person) => {
            setPerson(person.item);
            setShowPerson(true);
        });
    };
    const showVaccineInfo = (item) => __awaiter(void 0, void 0, void 0, function* () {
        setShowCard(true);
        setLoadingVaccine(true);
        const index = data === null || data === void 0 ? void 0 : data.findIndex((x) => x.proof_guid === item.proof_guid);
        if (index >= 0) {
            setSelectedItemIndex(index);
        }
        // medicalApi
        // 	.fetchPersonVaccineProofsFromGuid(item.proof_guid)
        // 	.then(async (res) => {
        // 		let shots: any = [];
        // 		for (let i = 0; i < res.items.shots.length; i++) {
        // 			const shot: any = res.items.shots[i];
        // 			shot.hasImage = await uploadApi.checkImage(res.items.shots[i].image_url);
        // 			shots.push(shot);
        // 		}
        // 		setLoadingVaccine(false);
        // 		setVaccineData({ ...res.items, ...{ shots: shots }, full_name: item.full_name });
        // 	})
        // 	.catch((e) => {
        // 		console.error(e);
        // 	});
    });
    const getVaccineIcon = (status) => {
        if (status && status.toLowerCase() === "none")
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        if (status && status.toLowerCase() === "eligible")
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        if (status && status.toLowerCase() === "in_progress")
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "regular", icon: "shield", color: "green" }) }));
        if (status && (status.toLowerCase() === "completed" || status.toLowerCase() === "full"))
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "solid", icon: "shield-check", color: "green" }) }));
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    const getVaccineType = (type_id) => {
        const type = vaccineType.find((type) => type.type_id === type_id);
        if (type) {
            return type.name;
        }
        else {
            return "N/A";
        }
    };
    const getVaccineCompany = (company_Guid) => {
        const company = vaccineCompany.find((company) => company.medical_vaccine_company_guid === company_Guid);
        if (company) {
            return company.company_name;
        }
        else {
            return "N/A";
        }
    };
    const shotId = (number, type) => String(number) + String(type);
    const submitHandle = (status, shot, reason) => {
        setSaving({ isLoading: true, id: shotId(shot.shot_number, shot.type_id) });
        if (status === "A") {
            setIsApproving({ isLoading: true, id: shotId(shot.shot_number, shot.type_id) });
        }
        else if (status === "P") {
            setIsPending({ isLoading: true, id: shotId(shot.shot_number, shot.type_id) });
        }
        else if (status === "R") {
            setIsRejecting({ isLoading: true, id: shotId(shot.shot_number, shot.type_id) });
        }
        let vaccineDataCopy = Object.assign({}, vaccineData);
        vaccineDataCopy === null || vaccineDataCopy === void 0 ? void 0 : vaccineDataCopy.shots.map((shotInner) => {
            if (shotInner.shot_number === shot.shot_number && shotInner.type_id === shot.type_id) {
                shotInner.status = status;
                if (status === "A" || status === "P")
                    shotInner.approver_reason = null;
                return shotInner;
            }
            return shotInner;
        });
        if (reason) {
            vaccineDataCopy === null || vaccineDataCopy === void 0 ? void 0 : vaccineDataCopy.shots.map((shotInner) => {
                if (shotInner.shot_number === shot.shot_number && shotInner.type_id === shot.type_id) {
                    shotInner.approver_reason = reason;
                    return shotInner;
                }
                return shotInner;
            });
        }
        let approval = {
            proof_guid: vaccineDataCopy === null || vaccineDataCopy === void 0 ? void 0 : vaccineDataCopy.proof_guid,
            shots: vaccineDataCopy === null || vaccineDataCopy === void 0 ? void 0 : vaccineDataCopy.shots.map((shot) => {
                var _a;
                return {
                    shot_number: shot.shot_number,
                    status: shot.status,
                    approver_reason: shot.approver_reason,
                    received_on: (_a = shot.received_on) !== null && _a !== void 0 ? _a : undefined,
                    type: shot.type_id
                };
            }),
        };
        setVaccineData((Prev) => (Object.assign(Object.assign({}, Prev), { shots: vaccineDataCopy === null || vaccineDataCopy === void 0 ? void 0 : vaccineDataCopy.shots })));
        //console.log("APPROVAL DATA",approval)
        MedicalApi_1.default
            .putVaccineProof(approval)
            .then((resp) => {
            var _a;
            if (resp.success) {
                setAlertMessage({ text: `Successfully updated shot number ${shot.shot_number} status for  ${vaccineData === null || vaccineData === void 0 ? void 0 : vaccineData.full_name}`, type: "success" });
                setTimeout(() => {
                    setAlertMessage({ text: "" });
                }, 5000);
                // setFilterValues((state: any) => ({ ...state, ...{ from: 1, to: data.length } }));
                // setReloading(true);
                //setLoading(true);
                if (((_a = vaccineDataCopy.shots[vaccineDataCopy.shots.length - 1]) === null || _a === void 0 ? void 0 : _a.shot_number) === shot.shot_number && selectedItemIndex !== null) {
                    setSelectedItemIndex(selectedItemIndex + 1);
                }
                //setShowCard(false);
            }
            if (resp.error) {
                setAlert({
                    error: true,
                    message: "Something went wrong. Contact support.",
                });
            }
        })
            .catch((err) => { })
            .finally(() => {
            setSaving({ isLoading: false, id: "" });
            setIsPending({ isLoading: false, id: "" });
            setIsApproving({ isLoading: false, id: "" });
            setIsRejecting({ isLoading: false, id: "" });
        });
    };
    (0, react_1.useEffect)(() => {
        setLoading(true);
        fetchReviews(tabs);
    }, [tabs]);
    (0, react_1.useEffect)(() => {
        if (!!isFiltering) {
            setLoading(true);
            fetchReviews(tabs);
            setIsFiltering(false);
        }
    }, [isFiltering]);
    const switchTab = (tab) => {
        setTabs(tab);
        setLoading(true);
        setData([]);
        updateFilterValues({ from: 1, to: configs.dataBatchSize });
    };
    const columns = [
        {
            id: "name",
            name: "Name",
            sortable: true,
            onSort: (data) => { setData(data); },
            formatter: (item) => {
                return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "clickable", onClick: () => {
                        showPersonInfo(item);
                    } }, { children: [(0, jsx_runtime_1.jsx)("span", { children: item.full_name }), "\u00A0", getVaccineIcon(item.vaccine_status)] })));
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Name",
            },
            filterable: true,
            filterOptions: {
                type: "textbox",
                onFilter: (item, value) => {
                    if (item.full_name !== null) {
                        if (item.full_name.toLowerCase().indexOf(value.toLowerCase()) != -1)
                            return true;
                    }
                    return false;
                },
            },
        },
        {
            id: "mit_id",
            name: "MIT ID",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "MIT ID",
            },
            filterable: false,
        },
        {
            id: "date_of_birth",
            name: "DOB",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Date of Birth",
            },
            filterable: false,
        },
        // {
        //     id: "address",
        //     name: "Address",
        //     sortable: false,
        //     options: {
        //         demandPopin: true,
        //         minWidth: 1000,
        //         popinText: "Address"
        //     }
        // },
        {
            id: "vaccine_type",
            name: "Vaccine Type",
            sortable: true,
            onSort: (data) => { setData(data); },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Vaccine Type",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: false,
                options: configs.vaccineCompanies,
                onFilter: (item, value) => {
                    if (value)
                        return item.vaccine_type.includes(value);
                    return true;
                },
            },
        },
        {
            id: "received_on",
            name: "Recieved on",
            sortable: true,
            onSort: (data) => { setData(data); },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Recieved on",
            },
            filterable: true,
            filterOptions: {
                type: "calendar",
                onFilter: (item, value) => {
                    if (value !== null && value !== undefined && value !== "") {
                        let fromDate = new Date(value.substr(value.indexOf(" ") + 1, value.indexOf("to ") - 6));
                        let toDate = new Date(value.substr(value.indexOf("to ") + 3));
                        toDate.setHours(23);
                        toDate.setMinutes(59);
                        toDate.setSeconds(59);
                        if (fromDate && toDate) {
                            var compareDate = new Date(item.received_on);
                            return compareDate.getTime() >= fromDate.getTime() && compareDate.getTime() <= toDate.getTime();
                        }
                        return true;
                    }
                    return true;
                },
            },
        },
        {
            id: "submission_date",
            name: "Submitted on",
            sortable: true,
            onSort: (data) => { setData(data); },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Submitted on",
            },
            filterable: true,
            filterOptions: {
                type: "calendar",
                onFilter: (item, value) => {
                    if (value !== null && value !== undefined && value !== "") {
                        let fromDate = new Date(value.substr(value.indexOf(" ") + 1, value.indexOf("to ") - 6));
                        let toDate = new Date(value.substr(value.indexOf("to ") + 3));
                        toDate.setHours(23);
                        toDate.setMinutes(59);
                        toDate.setSeconds(59);
                        if (fromDate && toDate) {
                            var compareDate = new Date(item.submission_date);
                            return compareDate.getTime() >= fromDate.getTime() && compareDate.getTime() <= toDate.getTime();
                        }
                        return true;
                    }
                    return true;
                },
            },
        },
        {
            id: "vaccine_status",
            name: "Status",
            sortable: true,
            onSort: (data) => { setData(data); },
            formatter: (item) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `clickable ${vaccineStatus(item.status).color}`, onClick: () => {
                    showVaccineInfo(item);
                } }, { children: (0, jsx_runtime_1.jsx)("span", { children: item.vaccine_status }) }))),
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Vaccine Status",
            },
            filterable: false,
        },
    ];
    let navItems = [];
    if (roles === null || roles === void 0 ? void 0 : roles.roles.includes("medical"))
        navItems = [
            {
                icon: "",
                iconOnly: false,
                text: "All",
                state: tabs === "All" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => switchTab("All"),
            },
            {
                icon: "",
                iconOnly: false,
                text: "Pending",
                state: tabs === "Pending" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => switchTab("Pending"),
            },
            {
                icon: "",
                iconOnly: false,
                text: "Approved",
                state: tabs === "Approved" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => switchTab("Approved"),
            },
            {
                icon: "",
                iconOnly: false,
                text: "Rejected",
                state: tabs === "Rejected" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
                onClick: () => switchTab("Rejected"),
            },
        ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "contacttracingtable" }, { children: (0, jsx_runtime_1.jsx)(hui_1.NavBar, { tabs: navItems, type: hui_1.NavBarTypes.Text, itemAlignment: hui_1.ItemAlignment.Left }) })), (0, jsx_runtime_1.jsx)(hui_1.Tooltip, Object.assign({ text: "Open Filter" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Small, text: "Filter", icon: "filter", onClick: () => {
                        onOpenFilters();
                    } }) })), filtered && ((0, jsx_runtime_1.jsx)(hui_1.Tooltip, Object.assign({ text: "Clear All Filter" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Small, text: "Clear", icon: "filter", onClick: () => {
                        onClearFilters();
                    } }) }))), (0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: data ? data : [], showExportButton: false, showFilterButton: false, isLoading: isLoading || covidNav.globalTableIsLoading, noDataText: "No results found", theme: "medical", sortStateOptions: {
                    enabled: true,
                    key: "covid-medical-vaccine-administered",
                }, growing: hasMore ? hui_1.TableGrowingMode.Button : hui_1.TableGrowingMode.None, onLoadMore: (e) => {
                    fetchReviews(tabs);
                }, moreText: isLoadingMore ? "Loading data, please wait..." : "Load more" }), !hasMore && (0, jsx_runtime_1.jsx)(hui_1.Alert, { text: "No more to load...", type: "info" }), (0, jsx_runtime_1.jsx)(PersonDetailsDrawer_1.default, { id: person === null || person === void 0 ? void 0 : person.mit_id, show: showPerson, onClose: viewPersonClose }), (0, jsx_runtime_1.jsx)(hui_1.TemplateModal, { show: showCard, onClose: methods.cancelUpdate, imageUrl: "", name: "vaccine-review-card", theme: "medical", size: hui_1.TemplateModalSize.ExtraLarge, bodyAlignment: hui_1.TemplateModalAlignment.Center, header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "External Vaccination Review", type: hui_1.TextType.Heading4, icon: "" }), body: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [alertMessage.text && (0, jsx_runtime_1.jsx)(hui_1.Alert, Object.assign({}, alertMessage)), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "container vaccination-review-container " }, { children: [alert.error && (0, jsx_runtime_1.jsx)(hui_1.Alert, { text: alert.message, type: "error" }), loadingVaccine ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row m-3 align-items-center justify-content-center vaccine-card no-gutters" }, { children: (0, jsx_runtime_1.jsx)(hui_1.SkeletonLoader, { type: "large-image" }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row m-3 align-items-center justify-content-center vaccine-card no-gutters" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-12 col-lg-12 text-center p-2" }, { children: (0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] }) })) }))] })) :
                                    ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row align-items-center justify-content-center vaccine-card no-gutters" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-12 col-lg-12 text-center" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "image p-2" }, { children: proofImages.length > 0 ? proofImages.map((proofImage) => ((0, jsx_runtime_1.jsx)("img", { onClick: () => setSelectedImage(proofImage), src: proofImage, alt: "" }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "No documents were uploaded", color: "red" }) })) })) })) })), (0, jsx_runtime_1.jsx)("hr", {}), vaccineData &&
                                                (vaccineData === null || vaccineData === void 0 ? void 0 : vaccineData.shots.map((shot, index) => {
                                                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row justify-content-center vaccine-card no-gutters mt-3" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-4 col-lg-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Name` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: vaccineData.full_name }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Dose` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: ((shot.type_id == 1) ? 'Shot ' : 'Booster ') + `${shot.shot_number}` }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Vaccine Type` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: getVaccineType(shot.type_id) }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Product Name` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: shot.company_name }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Status` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left", style: {
                                                                                            color: (shot.status === 'R') ? 'red' : (shot.status === 'A') ? 'green' : 'black'
                                                                                        } }, { children: (0, jsx_runtime_1.jsx)("strong", { children: (shot.status === 'R') ?
                                                                                                (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: 'times', type: "regular" }), " Rejected"] }) :
                                                                                                (shot.status === 'A') ?
                                                                                                    (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: 'check', type: "regular" }), " Approved"] }) :
                                                                                                    (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: "clock", type: "regular" }), " Pending"] }) }) }))] }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-4 col-lg-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Lot Number` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: shot.lot_number }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Received on` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)(hui_1.CalendarInput, { value: shot.received_on, id: "receivedOn", onChange: (date) => {
                                                                                                let data = vaccineData.shots.map((shotInner) => {
                                                                                                    if (shotInner.shot_number === shot.shot_number && shotInner.type_id === shot.type_id) {
                                                                                                        shotInner.received_on = date;
                                                                                                        return shotInner;
                                                                                                    }
                                                                                                    return shotInner;
                                                                                                });
                                                                                                setVaccineData((Prev) => (Object.assign(Object.assign({}, Prev), { shots: data })));
                                                                                            } }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Date Submitted` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: shot.submission_date }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-5 text-right" }, { children: `Healthcare Site` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-7 text-left" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: shot.location }) }))] }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "col-4 col-lg-4 px-2" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "justify-content-center mb-2" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "btn-full approve-vaccine mb-2" }, { children: [shot.type_id == 2 &&
                                                                                                (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "mb-2" }, { children: (0, jsx_runtime_1.jsx)("small", { children: "Please note: Approving a booster shot will also approve all previous shots that are still pending." }) })), (0, jsx_runtime_1.jsx)(hui_1.Button, { isBusy: isApproving.isLoading && isApproving.id === shotId(shot.shot_number, shot.type_id), icon: (shot.type_id == 2 && !hasBothDoses(vaccineData.shots)) ? "" : "check", state: shot.status === "A" || (shot.type_id == 2 && !hasBothDoses(vaccineData.shots)) || (isSaving.isLoading && isSaving.id === shotId(shot.shot_number, shot.type_id)) ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, overwriteColor: "success", text: (shot.type_id == 2 && !hasBothDoses(vaccineData.shots)) ? "Can't approve with previous shot(s) missing/rejected" : "Approve", onClick: () => {
                                                                                                    submitHandle("A", shot);
                                                                                                } })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "btn-full reject-vaccine" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "times", overwriteColor: "danger", outlined: true, text: "Reject", isBusy: isRejecting.isLoading && isRejecting.id === shotId(shot.shot_number, shot.type_id), state: (shot.type_id == 1 && hasApprovedBooster(vaccineData.shots)) || (isSaving.isLoading && isSaving.id === shotId(shot.shot_number, shot.type_id)) ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, onClick: () => {
                                                                                                let data = vaccineData.shots.map((shotInner) => {
                                                                                                    if (shotInner.shot_number === shot.shot_number && shotInner.type_id == shot.type_id) {
                                                                                                        shotInner.status = "R";
                                                                                                        return shotInner;
                                                                                                    }
                                                                                                    return shotInner;
                                                                                                });
                                                                                                setVaccineData((Prev) => (Object.assign(Object.assign({}, Prev), { shots: data })));
                                                                                            } }) }))] })), vaccineData.shots[index].status === "R" && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row mb-2 align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-3 text-right" }, { children: `Reason` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-9 text-left" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Dropdown, { id: "dropdown_reason", name: "reject", text: vaccineData.shots[index].approver_reason != null ? vaccineData.shots[index].approver_reason : "Reason for Reject", 
                                                                                            // value={configs.rejectReasonOptions.find((o: any) => o.reason_id === vaccineData.shots[index].approver_reason_id)?.text ?? undefined}
                                                                                            dropdownItems: configs.rejectReasonOptions, value: vaccineData === null || vaccineData === void 0 ? void 0 : vaccineData.shots[index].approver_reason, onChange: (item) => {
                                                                                                submitHandle("R", shot, item.text);
                                                                                                // let data = vaccineData.shots.map((shotInner: any) => {
                                                                                                // 	if (shotInner.shot_number === shot.shot_number) {
                                                                                                // 		shotInner.approver_reason_id = item.reason_id;
                                                                                                // 		return shotInner;
                                                                                                // 	}
                                                                                                // 	return shotInner;
                                                                                                // });
                                                                                                // setVaccineData((Prev: any) => ({ ...Prev, shots: data }));
                                                                                            } }) }))] })))] }))] })), (vaccineData === null || vaccineData === void 0 ? void 0 : vaccineData.shots.length) > 1 && index < (vaccineData === null || vaccineData === void 0 ? void 0 : vaccineData.shots.length) - 1 && (0, jsx_runtime_1.jsx)("hr", {})] }));
                                                }))] }))] }))] }), footer: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `d-flex justify-content-between next-prev-btns ${selectedItemIndex !== null && selectedItemIndex > 0 && "w-100"}` }, { children: [selectedItemIndex !== null && selectedItemIndex > 0 && (0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "chevron-left", text: "Previous", outlined: true, onClick: () => setSelectedItemIndex(selectedItemIndex - 1) }), selectedItemIndex !== null && selectedItemIndex !== (data === null || data === void 0 ? void 0 : data.length) - 1 && ((0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "chevron-right", text: "Next", outlined: true, onClick: () => setSelectedItemIndex(selectedItemIndex + 1) }))] })) }), (0, jsx_runtime_1.jsx)(hui_1.Drawer, { show: showFilters, type: hui_1.DrawerType.Left, size: hui_1.DrawerSize.Small, onClose: () => setShowFilters(false), themedColor: "medical", header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: `Filter ${tabs}`, type: hui_1.TextType.Heading4, icon: "" }), contents: (0, jsx_runtime_1.jsx)(hui_1.Form, Object.assign({ formValidationTrigger: "onBlur" }, { children: (formMethods) => {
                        let received_on = formMethods.watch("received_on");
                        let submission_date = formMethods.watch("submission_date");
                        (0, react_1.useEffect)(() => {
                            updateFilterValues({ received_on });
                        }, [received_on]);
                        (0, react_1.useEffect)(() => {
                            updateFilterValues({ submission_date });
                        }, [submission_date]);
                        return ((0, jsx_runtime_1.jsx)(hui_1.FormContainer, Object.assign({ methods: formMethods, formValidationTrigger: "onSubmit", id: "filter-form", submitText: "Filter", secondaryActionText: "Clear Filters", action: () => {
                                onFilterItems();
                            }, secondaryAction: () => {
                                onClearFilters();
                            } }, { children: columns.map((o, i) => !!o.filterable && getFilterInput(o, i)) })));
                    } })), footer: [] }), (0, jsx_runtime_1.jsx)(hui_1.TemplateModal, { show: !!selectedImage, imageUrl: "", name: "vaccine-review-card", theme: "medical", size: hui_1.TemplateModalSize.ExtraLarge, bodyAlignment: hui_1.TemplateModalAlignment.Center, header: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), body: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "container vaccination-image-review-container " }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "image p-2" }, { children: selectedImage && (0, jsx_runtime_1.jsx)("img", { src: selectedImage, alt: "" }) })) })), footer: (0, jsx_runtime_1.jsx)(hui_1.Button, { icon: "times", text: "Close", type: hui_1.ButtonType.Ghost | hui_1.ButtonType.Primary, onClick: () => setSelectedImage(null) }) })] }));
};
const VaccineReview = (0, mobx_react_1.inject)("peopleStore", "covidNav", "roles")((0, mobx_react_1.observer)(VaccineReviewComponent));
exports.default = VaccineReview;
